import React, { useEffect, useState } from 'react';
import Container from '../Container';
import Icon from '../Icons';
import { ButtonLink } from '../Link';
import { useGaEvent } from '../../hooks/hooks.ga-events';

const WidgetCard = ({
  widgetCard
}) => {
  const [colorButton, setColorButton] = useState('');
  const {
    colorTheme, title, description, email, phone,
    buttonModularContent, iconImageModularContent
  } = widgetCard || {};

  let icon = '';

  const {
    labelButton, url
  } = buttonModularContent[0] || {};

  const {
    iconType, imageType
  } = iconImageModularContent[0] || {};

  if (iconType && iconType) {
    switch (iconType) {
      case 'allegato':
        icon = 'attach-file';
        break;
      case 'carrello':
        icon = 'shopping-cart';
        break;
      case 'cuore':
        icon = 'favorite';
        break;
      case 'documento':
        icon = 'insert-drive-file';
        break;
      case 'email':
        icon = 'email';
        break;
      default:
        icon = '';
    }
  }

  const handleGaEvent = (eventAction) => {
    useGaEvent('Customer Relations', eventAction);
  };

  useEffect(() => {
    if (colorTheme && colorTheme === 'giallo') {
      setColorButton('yellow');
    }

    if (colorTheme && colorTheme === 'azzurro') {
      setColorButton('brand');
    }
  }, []);

  const classNameSection = `widget-card widget-card--theme-${colorButton}`;
  return (
    <Container className={classNameSection}>
      <div className="widget-card__wrapper">
        <div className="widget-card__container">
          <div className="widget-card__content">
            <div className="widget-card__information">
              <span className="widget-card__container-icon">
                {
                  imageType
                    ? <img src={imageType.url} className="widget-card__image" alt="" />
                    : (icon && <Icon className="widget-card__icon" path={`${icon}`} />)
                }
              </span>
              <div className="widget-card__text">
                {title && <h4 className="widget-card__title label-small">{title}</h4>}
                {
                  description && <div className="widget-card__description caption">{description}</div>
                }
                {
                  (email || phone) && (
                    <span className="widget-card__description widget-card__description--with-link caption">
                      {
                        email && (
                          <a onClick={() => handleGaEvent('Contact Mail')} href={`mailto:${email}`}>
                            {email}
                          </a>
                        )
                      }
                      {
                        phone && (
                          <a onClick={() => handleGaEvent('Contact Call')} href={`tel:/${phone}`}>
                            {phone}
                          </a>
                        )
                      }
                    </span>
                  )
                }
              </div>
            </div>
            {
              labelButton && url && (
                <ButtonLink
                  kind="small"
                  label={labelButton.value}
                  color={colorButton}
                  url={url}
                  className="widget-card__btn"
                />
              )
            }
          </div>
        </div>
      </div>
    </Container>
  );
};

WidgetCard.defaultProps = {
  labelButton: {
    value: 'ciao'
  }
};

export default WidgetCard;
